import { reactive } from "vue";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
}

const captchaStore = {
  state: reactive({
    captchaVerified: !!getCookie("captcha_verified"),
  }),
  setVerified(token) {
    setCookie("captcha_verified", token, 30);
    this.state.captchaVerified = true;
  },
  checkCookie() {
    this.state.captchaVerified = !!getCookie("captcha_verified");
    return this.state.captchaVerified;
  },
};

export default captchaStore;